import { useState } from 'react';
import { Field} from "formik";
import Select from "react-select";
import Translator from "../../../../components/helpers/Translator";
import DeleteModal from "../../../../components/Modal/DeleteModal";
import AppModal from "../../../../components/Modal/AppModal";
import { AppRemixIcon } from '@/layout/AppComponents';


const BlockHSRiskRegister = props => {
    const { index, arrayHelpers, values, disabled, report, onLevelUp } = props;
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showLevelUpModal, setShowLevelUpModal] = useState(false);
    const [levelUpOption, setLevelUpOption] = useState(null);

    const remove = () => {
        arrayHelpers.remove(index)
        setShowDeleteModal(false)
    }

    const handleLevelUp = async() => {
        try{
            const pgID = levelUpOption;
            setLevelUpOption(null)
            await onLevelUp({values: values.hsRiskRegister[index], plantGroupID: pgID, type: 'hsRiskRegister'})
            setShowLevelUpModal(false)
        }catch (err) {}
    }

    return (
        <div className="row mb-3" key={index}>
            <div className="col-12">
                <div className="card sr-header">
                    <div className="card-header">
                        <span className="text-uppercase"><b><Translator file='module-saicaReports' name='risk.register' /></b></span> Nº {index+1} {values.hsRiskRegister[index].originTier && <span className="btn btn-xs btn-warning" style={{marginLeft: '10px'}}><Translator file='module-saicaReports' name='from' />: <b>{values.hsRiskRegister[index].originTier}</b></span>}
                        <span className={`float-right btn btn-danger btn-sm pointer ${disabled && 'disabled'}`} onClick={() => !disabled && setShowDeleteModal(true)}><AppRemixIcon icon="delete-bin" /></span>
                        <span className={`float-right btn btn-info btn-sm pointer mr-2 ${!report.levelUpPermissions && 'disabled'}`} onClick={() => report.levelUpPermissions && setShowLevelUpModal(true)}><AppRemixIcon icon="corner-right-up" /></span>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="text-bold">
                                    (<Translator file='module-saicaReports' name='serious.unacceptable.risk' />)
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div>
                            <div className="row">
                                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                    <label className="col-form-label">
                                        <Translator file='module-saicaReports' name='risk' />
                                    </label>
                                </div>
                                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                    <Field name={`hsRiskRegister[${index}].risk`} className={"form-control mb-2"} disabled={disabled} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                    <label className="col-form-label">
                                        <Translator file='module-saicaReports' name='action' />
                                    </label>
                                </div>
                                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                    <Field name={`hsRiskRegister[${index}].action`} className={"form-control mb-2"} disabled={disabled} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                    <label className="col-form-label">
                                        <Translator file='module-saicaReports' name='rating' />
                                    </label>
                                </div>
                                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                    <Field name={`hsRiskRegister[${index}].rating`} className={"form-control mb-2"} disabled={disabled} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                    <label className="col-form-label">
                                        <Translator file='module-saicaReports' name='comments' />
                                    </label>
                                </div>
                                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                    <Field name={`hsRiskRegister[${index}].comments`} className={"form-control mb-2"} disabled={disabled} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DeleteModal show={showDeleteModal} onConfirm={() => remove()} onClose={() => setShowDeleteModal(false)} />
            <AppModal show={showLevelUpModal}
                          isConfirmBtn={false}
                          isCancelBtn={true}
                          cancelBtnText={<Translator file='module-saicaReports' name='cancel' />}
                          title={<Translator file='module-saicaReports' name='level.up' />}
                          onClose={() => {
                              setShowLevelUpModal(false)
                          }}
            >
                <p>
                    <Translator file='module-saicaReports' name='want.level.up.current.state.block' />
                </p>
                <p>
                    <Translator file='module-saicaReports' name='select.tier.level.send' />
                </p>
                {report.levelUpPermissions && (
                    <Select className="mb-3"
                            options={report.levelUpPermissions}
                            onChange={opt => setLevelUpOption(opt.value)}
                            value={levelUpOption ? report.levelUpPermissions.find(p => p.value === levelUpOption) : null}
                    />
                )}
                <span className={`btn btn-info btn-block ${!levelUpOption && 'disabled'}`} onClick={() => levelUpOption && handleLevelUp()}><Translator file='module-saicaReports' name='level.up' /></span>
            </AppModal>
        </div>
    );
};

export default BlockHSRiskRegister;
